export default __webpack_public_path__ + "static/media/certificate.1705890b.png";